var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image && (_vm.image.sizes || {}).large)?_c('div',{staticClass:"ArticleComp relative w-full bg-black bg-full",style:({
    paddingBottom: '56.25%',
    backgroundImage: ("url('" + (_vm.image.sizes.large) + "')")
  }),attrs:{"role":"img","aria-label":_vm.image.title,"title":_vm.image.title}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }